export type SortDirection = 'asc' | 'desc';

/**
 * Sortier-Pfeil der Tabellen-Header: ↑/↓ fuer die aktive Spalte, sonst ↕ (per CSS
 * in hellem Grau). Eine Stelle fuer alle Tabellen — die Glyphen lagen dreifach im
 * Code und liefen dadurch auseinander (Review PR #703 N5).
 */
export function sortIndicatorFor<K>(
  activeKey: K | null | undefined,
  key: K,
  direction: SortDirection,
): string {
  if (activeKey !== key) return '↕';
  return direction === 'asc' ? '↑' : '↓';
}
